const BOOKING_URL = "https://api.leadconnectorhq.com/widget/booking/AK3IH1nwEwNhiDkL4Iak";

const professionals = {
  fr: {
    locale: "fr",
    phone: "+33756868432",
    phoneDisplay: "07 56 86 84 32",
    bookingUrl: BOOKING_URL,
    nav: {
      login: "Connexion",
      cta: "Souscrire",
      langSwitcher: [
        { code: "fr", label: "FR", path: "/fr/professionnels" },
        { code: "es", label: "ES", path: "/es/profesionales" },
        { code: "en", label: "EN", path: "/en/professionals" },
      ],
    },
    hero: {
      title: "Votre couverture conçue pour les professionnels de la location courte durée",
      subtitle: "Protégez vos logements pour seulement 0,52€ par jour !",
      ctaPrimary: "J'assure mon logement",
      ctaCall: "Appeler le service client",
    },
    compensations: {
      title: "Compensations",
      items: [
        {
          title: "Vandalisme",
          amount: "50 000€",
          description: "Remboursement jusqu'à 50 000€ pour les dégâts causés par vos voyageurs dans vos hébergements.",
        },
        {
          title: "Punaises de lit",
          amount: "10 000€",
          description: "Soyez couvert jusqu'à 10 000€ en cas de punaises de lit trouvées dans votre hébergement.",
        },
        {
          title: "Remboursement express",
          amount: "48h max",
          description: "Une garantie de remboursement sous 48h maximum directement sur votre compte bancaire.",
        },
      ],
    },
    fullCoverage: {
      title: "La protection la plus complète du marché pour la location courte durée.",
      cta: "Découvrir les garanties",
    },
    guarantees: {
      title: "Ce que HostProtect vous garantit",
      items: [
        {
          title: "Parasites",
          description: "Traitement des punaises de lit, cafards ou autres nuisibles. Prise en charge rapide et efficace de l'hébergement.",
        },
        {
          title: "Vandalisme",
          description: "Remboursement des dégâts causés par les voyageurs : meubles, murs, équipements, jusqu'à 50 000€.",
        },
        {
          title: "Relogement",
          description: "En cas de sinistre, vos voyageurs sont relogés à l'hôtel + repas. Remboursement jusqu'à 1 000€ sur facture.",
        },
        {
          title: "Perte d'exploitation",
          description: "Si l'hébergement est inutilisable, votre revenu est protégé, jusqu'à 2 semaines de loyers.",
        },
      ],
    },
    subscribeBanner: {
      title: "Souscrivez en 2 minutes seulement !",
      cta: "Je protège mon premier logement",
    },
    useCases: {
      title: "Pourquoi ne pas agir maintenant ?",
      subtitle: "Chaque jour sans protection, c'est un risque de plus.",
      items: [
        {
          scenario: "Un groupe de fêtards détruit votre salon",
          consequence: "3 000€ de dégâts. Votre caution de 500€ ne couvre rien. Airbnb refuse votre réclamation après des semaines de procédure.",
          solution: "Avec HostProtect : remboursement intégral sous 48h. Sans discussion.",
        },
        {
          scenario: "Des punaises de lit après un séjour",
          consequence: "Logement inutilisable pendant 2 semaines. Perte de revenus + frais de traitement de 2 500€. Aucune plateforme ne vous couvre.",
          solution: "Avec HostProtect : traitement couvert + perte d'exploitation indemnisée jusqu'à 2 semaines de loyers.",
        },
        {
          scenario: "Un voyageur casse la TV, le mobilier et les murs",
          consequence: "1 500€ de remplacement. Booking.com ne couvre RIEN. Vous êtes seul face aux dégâts.",
          solution: "Avec HostProtect : remboursement rapide sur facture, franchise de 10% du sinistre (min. 150€).",
        },
      ],
    },
    testimonials: [
      {
        name: "Marie L.",
        role: "Gestionnaire à Paris — 12 logements",
        text: "Depuis que j'utilise HostProtect, je dors sur mes deux oreilles. Un sinistre de 4 500€ remboursé en 48h. Je recommande à tous les gestionnaires.",
        stars: 5,
      },
      {
        name: "Thomas D.",
        role: "Conciergerie à Lyon — 25 logements",
        text: "AirCover m'a laissé tomber 3 fois. HostProtect a réglé mon sinistre en 2 jours. Le rapport qualité/prix est imbattable pour la tranquillité que ça apporte.",
        stars: 5,
      },
      {
        name: "Sophie M.",
        role: "Agence à Marseille — 8 logements",
        text: "Les punaises de lit, c'est le cauchemar de tout gestionnaire. HostProtect est le seul à les couvrir. Ça a littéralement sauvé mon business.",
        stars: 5,
      },
    ],
    video: {
      url: "/temognage.mp4",
      title: "Ils nous font confiance",
      subtitle: "Découvrez comment nos clients protègent leurs logements au quotidien.",
      fallbackText: "Témoignage vidéo bientôt disponible",
    },
    pricing: {
      title: "HostProtect, une tarification claire et précise",
      warning: "Notre offre est exclusivement réservée aux professionnels de la location courte durée",
      plan: {
        price: "189,00€ HT",
        period: "HT /an /logement",
        ctaPrimary: "J'assure mon premier logement",
        ctaVolume: "J'ai 5 logements ou plus",
        ctaCallback: "Je veux être rappelé",
        features: [
          { text: "Jusqu'à 50 000€ de couverture", highlight: true },
          { text: "Parasites et punaises de lit couverts jusqu'à 10 000€", highlight: true },
          { text: "Remboursement sous 24 à 48h", highlight: true },
          { text: "Perte d'exploitation incluse", highlight: true },
          { text: "Frais de relogement jusqu'à 1 000€", highlight: true },
        ],
        note: "Franchise de 10% du montant du sinistre (minimum 150€) par sinistre déclaré. Aucune vétusté appliquée.",
        priceNote: "Prix annoncé pour une souscription jusqu'au 31 décembre, réglée annuellement via le terminal de paiement en ligne Stripe.",
      },
    },
    comparison: {
      titleHp: "Avec HostProtect",
      titlePlatforms: "Sans HostProtect",
      hpFeatures: [
        "Couverture jusqu'à 50 000€",
        "Punaises et parasites couverts jusqu'à 10 000€",
        "Remboursement sous 24 à 48h",
        "Perte d'exploitation incluse",
        "Frais de relogement jusqu'à 1 000€",
      ],
      platformDeficiencies: [
        "Booking.com ne couvre RIEN",
        "Airbnb couvre partiellement",
        "Procédures longues et incertaines",
        "Aucune indemnisation fournie",
        "Pénalités et frais en cas de relogement",
        "Solution partielle ou inexistante",
      ],
    },
    volume: {
      title: "Vous avez 5 logements ou plus ?",
      description: "Notre offre s'adapte au volume de biens gérés par votre entreprise. Prenons quelques minutes pour en discuter afin de vous proposer une offre sur-mesure.",
      cta: "Prendre rendez-vous",
    },
    stats: {
      title: "Quelques chiffres 2024 pour nos clients",
      cta: "Je veux être rappelé",
      items: [
        { value: "10 000+", label: "logements assurés" },
        { value: "98%", label: "sinistres réglés" },
      ],
    },
    faq: {
      title: "Vous hésitez ?",
      subtitle: "Ces questions vous aideront à y voir plus clair",
      bookingText: "Si vous avez besoin d'un éclaircissement, n'hésitez pas à prendre rendez-vous avec notre commercial.",
      items: [
        {
          question: "Quel est le montant de la franchise ?",
          answer: "10% du montant du sinistre, avec un minimum de 150€, quel que soit le type de dommage.",
        },
        {
          question: "Quels objets ou cas sont exclus ?",
          answer: "Vol ou disparition d'objets, même avec effraction. Usure normale, défaut d'entretien, panne ou dysfonctionnement. Dommages causés intentionnellement ou par un tiers non autorisé. Sous-location, usage professionnel ou activité interdite.",
        },
        {
          question: "Les objets de loisirs sont-ils couverts ?",
          answer: "Oui, jusqu'à 1 000€ par an, à condition qu'ils soient mis à disposition des voyageurs et explicitement mentionnés dans l'annonce du logement. Exemples : vélos, skis, luges, barbecue, plancha, trottinettes, etc.",
        },
        {
          question: "Comment déclarer un sinistre ?",
          answer: "1. Connectez-vous à votre espace client. 2. Déclarez le sinistre dans les 15 jours suivant l'incident. 3. Joignez les documents : constat détaillé, photos du sinistre, facture ou preuve d'achat si disponible, rapport du prestataire ou de la plateforme le cas échéant, facture de l'intervention. L'indemnisation est généralement traitée sous 24 à 48h après validation du dossier.",
        },
      ],
    },
    finalCta: {
      title: "Prêt à protéger vos logements ?",
      subtitle: "Souscrivez en 2 minutes ou prenez rendez-vous avec notre équipe.",
      ctaPrimary: "Souscrire maintenant",
      ctaBooking: "Prendre rendez-vous",
      ctaCall: "Appeler le service client",
    },
    footer: {
      rights: "© 2025 HostProtect. Tous droits réservés.",
      phone: "07 56 86 84 32",
    },
  },

  es: {
    locale: "es",
    phone: "+33756868432",
    phoneDisplay: "07 56 86 84 32",
    bookingUrl: BOOKING_URL,
    nav: {
      login: "Iniciar sesión",
      cta: "Contratar",
      langSwitcher: [
        { code: "fr", label: "FR", path: "/fr/professionnels" },
        { code: "es", label: "ES", path: "/es/profesionales" },
        { code: "en", label: "EN", path: "/en/professionals" },
      ],
    },
    hero: {
      title: "Tu cobertura diseñada para profesionales del alquiler vacacional",
      subtitle: "¡Protege tus propiedades por solo 0,52€ al día!",
      ctaPrimary: "Asegurar mi propiedad",
      ctaCall: "Llamar al servicio",
    },
    compensations: {
      title: "Coberturas",
      items: [
        {
          title: "Vandalismo",
          amount: "50.000€",
          description: "Reembolso hasta 50.000€ por daños causados por huéspedes en tus alojamientos.",
        },
        {
          title: "Chinches",
          amount: "10.000€",
          description: "Cobertura hasta 10.000€ en caso de chinches encontradas en tu alojamiento.",
        },
        {
          title: "Reembolso exprés",
          amount: "48h máx",
          description: "Garantía de reembolso en 48h máximo directamente en tu cuenta bancaria.",
        },
      ],
    },
    fullCoverage: {
      title: "La protección más completa del mercado para el alquiler vacacional.",
      cta: "Descubrir las garantías",
    },
    guarantees: {
      title: "Lo que HostProtect te garantiza",
      items: [
        {
          title: "Plagas",
          description: "Tratamiento de chinches, cucarachas u otras plagas. Gestión rápida y eficaz del alojamiento.",
        },
        {
          title: "Vandalismo",
          description: "Reembolso por daños causados por huéspedes: muebles, paredes, equipamiento, hasta 50.000€.",
        },
        {
          title: "Realojamiento",
          description: "En caso de siniestro, tus huéspedes son realojados en hotel + comidas. Reembolso hasta 1.000€.",
        },
        {
          title: "Lucro cesante",
          description: "Si el alojamiento no está disponible, tu ingreso está protegido. Indemnización hasta 5.000€.",
        },
      ],
    },
    subscribeBanner: {
      title: "¡Contrata en solo 2 minutos!",
      cta: "Proteger mi primera propiedad",
    },
    useCases: {
      title: "¿Por qué no actuar ahora?",
      subtitle: "Cada día sin protección es un riesgo más.",
      items: [
        {
          scenario: "Un grupo de fiesta destroza tu salón",
          consequence: "3.000€ en daños. Tu depósito de 500€ no cubre nada. Airbnb rechaza tu reclamación tras semanas de espera.",
          solution: "Con HostProtect: reembolso íntegro en 48h. Sin discusión.",
        },
        {
          scenario: "Chinches después de una estancia",
          consequence: "Alojamiento inutilizable durante 2 semanas. Pérdida de ingresos + 2.500€ de tratamiento. Ninguna plataforma te cubre.",
          solution: "Con HostProtect: tratamiento cubierto + lucro cesante indemnizado hasta 5.000€.",
        },
        {
          scenario: "Un huésped rompe la TV, muebles y paredes",
          consequence: "1.500€ de reposición. Booking.com no cubre NADA. Estás solo ante los daños.",
          solution: "Con HostProtect: reembolso rápido con factura, franquicia del 10% del siniestro (mín. 150€).",
        },
      ],
    },
    testimonials: [
      {
        name: "Carlos R.",
        role: "Gestor en Barcelona — 15 propiedades",
        text: "Desde que uso HostProtect, gestiono mis propiedades con total tranquilidad. Un siniestro de 3.800€ resuelto en 48h. Imprescindible.",
        stars: 5,
      },
      {
        name: "Ana M.",
        role: "Agencia en Madrid — 20 propiedades",
        text: "Ninguna plataforma me cubría las chinches. HostProtect sí. En temporada alta, eso vale oro.",
        stars: 5,
      },
      {
        name: "Pedro L.",
        role: "Gestor en Valencia — 10 propiedades",
        text: "El reembolso más rápido que he visto. 48 horas y el dinero estaba en mi cuenta. Sin papeleo interminable.",
        stars: 5,
      },
    ],
    video: {
      url: "",
      title: "Confían en nosotros",
      subtitle: "Descubre cómo nuestros clientes protegen sus propiedades.",
      fallbackText: "Vídeo testimonio próximamente",
    },
    pricing: {
      title: "HostProtect, precios claros y precisos",
      warning: "Nuestra oferta es exclusiva para profesionales del alquiler vacacional",
      plan: {
        price: "189,00€ HT",
        period: "+ IVA /año /propiedad",
        ctaPrimary: "Asegurar mi primera propiedad",
        ctaVolume: "Tengo 5 o más propiedades",
        ctaCallback: "Quiero que me llamen",
        features: [
          { text: "Hasta 50.000€ de cobertura", highlight: true },
          { text: "Plagas y chinches cubiertos hasta 10.000€", highlight: true },
          { text: "Reembolso en 24 a 48h", highlight: true },
          { text: "Lucro cesante incluido", highlight: true },
          { text: "Gastos de realojamiento hasta 1.000€", highlight: true },
        ],
        note: "Franquicia del 10% del importe del siniestro (mínimo 150€) por siniestro. Sin depreciación aplicada.",
        priceNote: "Precio para suscripción hasta el 31 de diciembre, pago anual vía Stripe.",
      },
    },
    comparison: {
      titleHp: "Con HostProtect",
      titlePlatforms: "Sin HostProtect",
      hpFeatures: [
        "Cobertura hasta 50.000€",
        "Plagas y chinches cubiertos hasta 10.000€",
        "Reembolso en 24 a 48h",
        "Lucro cesante incluido",
        "Gastos de realojamiento hasta 1.000€",
      ],
      platformDeficiencies: [
        "Booking.com no cubre NADA",
        "Airbnb cubre parcialmente",
        "Procedimientos largos e inciertos",
        "Ninguna indemnización proporcionada",
        "Penalizaciones y gastos por realojamiento",
        "Solución parcial o inexistente",
      ],
    },
    volume: {
      title: "¿Tienes 5 propiedades o más?",
      description: "Nuestra oferta se adapta al volumen de propiedades gestionadas por tu empresa. Hablemos unos minutos para ofrecerte una propuesta a medida.",
      cta: "Reservar cita",
    },
    stats: {
      title: "Cifras 2024 de nuestros clientes",
      cta: "Quiero que me llamen",
      items: [
        { value: "10 000+", label: "propiedades aseguradas" },
        { value: "98%", label: "siniestros resueltos" },
      ],
    },
    faq: {
      title: "¿Tienes dudas?",
      subtitle: "Estas preguntas te ayudarán a verlo más claro",
      bookingText: "Si necesitas una aclaración, no dudes en reservar una cita con nuestro equipo comercial.",
      items: [
        {
          question: "¿Cuál es el importe de la franquicia?",
          answer: "10% del importe del siniestro, con un mínimo de 150€, independientemente del tipo de daño.",
        },
        {
          question: "¿Qué objetos o casos están excluidos?",
          answer: "Robo o desaparición de objetos, incluso con allanamiento. Desgaste normal, falta de mantenimiento, avería o mal funcionamiento. Daños causados intencionalmente o por un tercero no autorizado. Subarriendo, uso profesional o actividad prohibida.",
        },
        {
          question: "¿Los objetos de ocio están cubiertos?",
          answer: "Sí, hasta 1.000€ al año, siempre que estén a disposición de los huéspedes y mencionados explícitamente en el anuncio. Ejemplos: bicicletas, esquís, trineos, barbacoa, plancha, patinetes, etc.",
        },
        {
          question: "¿Cómo declarar un siniestro?",
          answer: "1. Inicia sesión en tu área de cliente. 2. Declara el siniestro en los 15 días siguientes al incidente. 3. Adjunta: informe detallado, fotos, factura o prueba de compra, informe del proveedor, factura de intervención. La indemnización se procesa generalmente en 24 a 48h tras la validación del expediente.",
        },
      ],
    },
    finalCta: {
      title: "¿Listo para proteger tus propiedades?",
      subtitle: "Contrata en 2 minutos o reserva una cita con nuestro equipo.",
      ctaPrimary: "Contratar ahora",
      ctaBooking: "Reservar cita",
      ctaCall: "Llamar al servicio",
    },
    footer: {
      rights: "© 2025 HostProtect. Todos los derechos reservados.",
      phone: "07 56 86 84 32",
    },
  },

  en: {
    locale: "en",
    phone: "+33756868432",
    phoneDisplay: "+33 1 89 74 01 18",
    bookingUrl: BOOKING_URL,
    nav: {
      login: "Log in",
      cta: "Get covered",
      langSwitcher: [
        { code: "fr", label: "FR", path: "/fr/professionnels" },
        { code: "es", label: "ES", path: "/es/profesionales" },
        { code: "en", label: "EN", path: "/en/professionals" },
      ],
    },
    hero: {
      title: "Insurance built for short-term rental professionals",
      subtitle: "Protect your properties for just €0.52 per day!",
      ctaPrimary: "Insure my property",
      ctaCall: "Call our team",
    },
    compensations: {
      title: "Coverage",
      items: [
        {
          title: "Vandalism",
          amount: "€50,000",
          description: "Reimbursement up to €50,000 for damages caused by guests in your properties.",
        },
        {
          title: "Bed bugs",
          amount: "€10,000",
          description: "Coverage up to €10,000 in case of bed bugs found in your accommodation.",
        },
        {
          title: "Express refund",
          amount: "48h max",
          description: "Guaranteed reimbursement within 48 hours directly to your bank account.",
        },
      ],
    },
    fullCoverage: {
      title: "The most comprehensive short-term rental protection on the market.",
      cta: "See all guarantees",
    },
    guarantees: {
      title: "What HostProtect guarantees you",
      items: [
        {
          title: "Pest control",
          description: "Treatment of bed bugs, cockroaches or other pests. Quick and effective handling of the property.",
        },
        {
          title: "Vandalism",
          description: "Reimbursement for damages caused by guests: furniture, walls, equipment, up to €50,000.",
        },
        {
          title: "Guest relocation",
          description: "In case of a claim, your guests are relocated to a hotel + meals. Reimbursement up to €1,000.",
        },
        {
          title: "Loss of revenue",
          description: "If the property is unusable, your income is protected. Compensation up to €5,000.",
        },
      ],
    },
    subscribeBanner: {
      title: "Subscribe in just 2 minutes!",
      cta: "Protect my first property",
    },
    useCases: {
      title: "Why wait any longer?",
      subtitle: "Every day without protection is another risk.",
      items: [
        {
          scenario: "A party group trashes your living room",
          consequence: "€3,000 in damages. Your €500 deposit covers nothing. Airbnb rejects your claim after weeks of back and forth.",
          solution: "With HostProtect: full reimbursement within 48h. No questions asked.",
        },
        {
          scenario: "Bed bugs discovered after a stay",
          consequence: "Property unusable for 2 weeks. Lost revenue + €2,500 treatment costs. No platform covers this.",
          solution: "With HostProtect: treatment covered + loss of revenue compensated up to €5,000.",
        },
        {
          scenario: "A guest breaks the TV, furniture and walls",
          consequence: "€1,500 in replacements. Booking.com covers NOTHING. You're on your own.",
          solution: "With HostProtect: fast reimbursement on invoice, 10% deductible on the claim (min. €150).",
        },
      ],
    },
    testimonials: [
      {
        name: "James W.",
        role: "Property Manager in London — 18 units",
        text: "Since switching to HostProtect, I've had complete peace of mind. A €4,500 claim settled in 48 hours. Every manager needs this.",
        stars: 5,
      },
      {
        name: "Sarah K.",
        role: "Concierge Service in Dublin — 30 units",
        text: "AirCover let me down three times. HostProtect delivered every single time. The value for money is unbeatable.",
        stars: 5,
      },
      {
        name: "Marco P.",
        role: "Agency in Lisbon — 12 units",
        text: "Bed bug coverage alone makes HostProtect worth it. No other insurer covers pests. It literally saved my business.",
        stars: 5,
      },
    ],
    video: {
      url: "",
      title: "They trust us",
      subtitle: "Discover how our clients protect their properties every day.",
      fallbackText: "Video testimonial coming soon",
    },
    pricing: {
      title: "HostProtect — clear and precise pricing",
      warning: "Our offer is exclusively for short-term rental professionals",
      plan: {
        price: "€189.00 excl. VAT",
        period: "excl. VAT /year /property",
        ctaPrimary: "Insure my first property",
        ctaVolume: "I have 5+ properties",
        ctaCallback: "Request a callback",
        features: [
          { text: "Up to €50,000 of coverage", highlight: true },
          { text: "Pests and bed bugs covered up to €10,000", highlight: true },
          { text: "Reimbursement within 24 to 48h", highlight: true },
          { text: "Loss of revenue included", highlight: true },
          { text: "Relocation expenses up to €1,000", highlight: true },
        ],
        note: "10% deductible on the claim amount (minimum €150) per declared claim. No depreciation applied.",
        priceNote: "Price for annual subscription until December 31st, paid annually via Stripe.",
      },
    },
    comparison: {
      titleHp: "With HostProtect",
      titlePlatforms: "Without HostProtect",
      hpFeatures: [
        "Coverage up to €50,000",
        "Pests and bed bugs covered up to €10,000",
        "Reimbursement within 24 to 48h",
        "Loss of revenue included",
        "Relocation expenses up to €1,000",
      ],
      platformDeficiencies: [
        "Booking.com covers NOTHING",
        "Airbnb covers partially",
        "Long and uncertain procedures",
        "No compensation provided",
        "Penalties and fees for relocation",
        "Partial or non-existent solution",
      ],
    },
    volume: {
      title: "Do you have 5 or more properties?",
      description: "Our offer adapts to the volume of properties managed by your company. Let's take a few minutes to discuss and offer you a tailored proposal.",
      cta: "Book a call",
    },
    stats: {
      title: "Key figures from 2024",
      cta: "Request a callback",
      items: [
        { value: "10,000+", label: "properties insured" },
        { value: "98%", label: "claims settled" },
      ],
    },
    faq: {
      title: "Still hesitating?",
      subtitle: "These questions will help you see things more clearly",
      bookingText: "Need clarification? Don't hesitate to book a call with our sales team.",
      items: [
        {
          question: "What is the deductible amount?",
          answer: "10% of the claim amount, with a minimum of €150, regardless of the type of damage.",
        },
        {
          question: "What objects or cases are excluded?",
          answer: "Theft or disappearance of objects, even with break-in. Normal wear and tear, lack of maintenance, breakdown. Intentional damage or damage by unauthorized third party. Subletting, professional use or prohibited activity.",
        },
        {
          question: "Are leisure items covered?",
          answer: "Yes, up to €1,000 per year, provided they are made available to guests and listed in the property ad. Examples: bikes, skis, sleds, barbecue, scooters, etc.",
        },
        {
          question: "How to report a claim?",
          answer: "1. Log in to your client area. 2. Report the claim within 15 days of the incident. 3. Attach: detailed report, photos, invoice or proof of purchase, provider report, intervention invoice. Compensation is usually processed within 24 to 48h after file validation.",
        },
      ],
    },
    finalCta: {
      title: "Ready to protect your properties?",
      subtitle: "Subscribe in 2 minutes or book a call with our team.",
      ctaPrimary: "Subscribe now",
      ctaBooking: "Book a call",
      ctaCall: "Call our team",
    },
    footer: {
      rights: "© 2025 HostProtect. All rights reserved.",
      phone: "+33 1 89 74 01 18",
    },
  },
};

export default professionals;
